import React from 'react'

import styles from './index.module.css'

type Props = {
  canIncrement: boolean
  canDecrement: boolean
  onIncrement: () => void
  onDecrement: () => void
}

export const ZoomControl: React.FC<Props> = ({
  canIncrement,
  canDecrement,
  onIncrement,
  onDecrement,
}) => (
  <div className={styles.container} data-testid="zoom-control">
    <button
      type="button"
      aria-label="縮小"
      data-testid="zoom-out"
      className={styles.button}
      disabled={!canDecrement}
      onClick={onDecrement}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z" />
      </svg>
    </button>
    <button
      type="button"
      aria-label="拡大"
      data-testid="zoom-in"
      className={styles.button}
      disabled={!canIncrement}
      onClick={onIncrement}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm2.5-4h-2v2H9v-2H7V9h2V7h1v2h2v1z" />
      </svg>
    </button>
  </div>
)
